import Model from "model";
import dateutil from "dateutil";
import moment from "moment";

class Activity extends Model {
  constructor(data) {
    super();
    var getterMethods = {
      canBuy() {
        return this.status === 1 || this.status === 4;
      },
      statusText() {
        var result = {
          1: "售票中",
          2: "已停售",
          3: "已结束",
          4: "预售中",
          5: "退票中",
          6: "待开售",
          0: "暂时缺票",
        }[this.status];
        return result;
      },
      duration: function () {
        let event = (this.events || [])[0];
        if (!event) {
          return "";
        }

        if (!event.end) {
          return "";
        }

        let seconds = event.end - event.start;

        let minutes = Math.ceil(seconds / 60 / 1000);
        let result = `${minutes}分钟`;
        return result;
      },
      availableEvents: function () {
        if (this.events) {
          let events = this.events;
          if (!this._availableEvents) {
            this._availableEvents = events.filter((event) => {
              return event.status == 1 && event.ticketsNumber;
            });
          }
          return this._availableEvents;
        } else return "";
      },
      period: function () {
        let events = this.events;
        let formatYMD = "YYYY年M月D日";
        let formatMD = "M月D日";
        let formatD = "D日";

        if (!events || !events.length) {
          return "";
        } else if (events.length == 1) {
          return moment(events[0].start).format(formatYMD);
        } else {
          let firstEvent = events[0];
          let lastEvent = events[events.length - 1];

          let from = moment(firstEvent.start).format(formatYMD);
          var to;

          if (dateutil.isSameDate(firstEvent.start, lastEvent.start)) {
            return from;
          }

          if (dateutil.isSameMonth(firstEvent.start, lastEvent.start)) {
            to = moment(lastEvent.start).format(formatD);
          } else if (dateutil.isSameYear) {
            to = moment(lastEvent.start).format(formatMD);
          } else {
            to = moment(lastEvent.start).format(formatYMD);
          }

          return `${from} - ${to}`;
        }
      },
    };
    // data.generalAgency = false
    // data.status = 6
    // data.showStartRemind = true
    // data.startSellTime = 1507632823163
    if (data.duration) delete getterMethods.duration;
    if (data.timeRange) {
      getterMethods.period = function () {
        return data.timeRange;
      };
    }

    this.setDataForInstance(data, getterMethods);
  }
}

export default Activity;



// WEBPACK FOOTER //
// ./src/activity/model/activity.js